import clinicAPI from "../../../services/clinicApi";
import { statusLabel } from "../../../utils/appointmentLabels";
import { hasAdminAccess, hasTrainerAccess } from "../../../utils/roles";
import s from "../clinic.module.css";

const ADMIN_ACTIONS = {
  scheduled: [
    { status: "confirmed", label: "Подтвердить" },
    { status: "cancelled", label: "Отменить" },
    { status: "no_show", label: "Не явился" },
  ],
  confirmed: [
    { status: "in_progress", label: "Идёт занятие" },
    { status: "cancelled", label: "Отменить" },
    { status: "no_show", label: "Не явился" },
  ],
  in_progress: [
    { status: "completed", label: "Завершить" },
    { status: "cancelled", label: "Отменить" },
  ],
  completed: [],
  cancelled: [],
  no_show: [],
};

const DOCTOR_ACTIONS = {
  scheduled: [
    { status: "confirmed", label: "Подтвердить" },
    { status: "in_progress", label: "Идёт занятие" },
    { status: "cancelled", label: "Отменить" },
    { status: "no_show", label: "Не явился" },
  ],
  confirmed: [
    { status: "in_progress", label: "Идёт занятие" },
    { status: "cancelled", label: "Отменить" },
    { status: "no_show", label: "Не явился" },
  ],
  in_progress: [{ status: "completed", label: "Завершить" }],
  completed: [],
  cancelled: [],
  no_show: [],
};

export default function AppointmentActions({
  appointment,
  role = "admin",
  onUpdated,
  compact = false,
}) {
  const map =
    role === "doctor" && !hasAdminAccess(role) ? DOCTOR_ACTIONS : ADMIN_ACTIONS;
  const actions = [...(map[appointment.status] || [])];
  const pastVisit =
    new Date(appointment.end_datetime).getTime() < Date.now();
  if (
    pastVisit &&
    (hasAdminAccess(role) || hasTrainerAccess(role)) &&
    !["completed", "cancelled", "no_show"].includes(appointment.status)
  ) {
    actions.push({ status: "completed", label: "Завершить занятие" });
  }

  const apply = async (status) => {
    try {
      await clinicAPI.updateAppointmentStatus(appointment.id, status);
      onUpdated?.();
    } catch (e) {
      alert(e.response?.data?.error || "Не удалось обновить статус");
    }
  };

  if (!actions.length) {
    return (
      <span style={{ fontSize: 12, color: "var(--color-text-muted)" }}>
        {statusLabel(appointment.status)}
      </span>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        gap: 6,
        flexWrap: "wrap",
        justifyContent: compact ? "flex-end" : "flex-start",
      }}
    >
      {actions.map((a) => (
        <button
          key={a.status}
          type="button"
          className={`${s.btn} ${s.btnSecondary} ${s.btnSmall}`}
          onClick={() => apply(a.status)}
        >
          {a.label}
        </button>
      ))}
    </div>
  );
}
